import AppModalContainer from '@nxsys/components/AppModalContainer';
import PSRBatchListing from '../../revenueFilings/listing/PSRBatch';
import SubmitPSR from '../../submitPSR';

/**
 * NX-6140: the history and error tiles used to open the per-employee PSR
 * screens, which showed one row per payslip. A payroll run is filed as one
 * submission now, so both open PSR Submissions instead - the error tile with
 * the listing already narrowed to submissions that need attention.
 */
export enum PSRModalTypeEnum {
  SUBMIT_PSR = 'SUBMIT_PSR',
  PSR_ERROR_SUBMISSIONS = 'PSR_ERROR_SUBMISSIONS',
  PSR_HISTORY = 'PSR_HISTORY',
}

type Props = {
  isOpen: boolean;
  toggle: () => void;
  type: PSRModalTypeEnum;
  cbAfterAction?: () => void;
};

const PSRModal: React.FC<Props> = ({ isOpen, toggle, type, cbAfterAction = () => { } }) => {
  const renderContentByType = () => {
    switch (type) {
      case PSRModalTypeEnum.SUBMIT_PSR:
        return <SubmitPSR cbAfterAction={cbAfterAction} isDashboard />;
      case PSRModalTypeEnum.PSR_ERROR_SUBMISSIONS:
        return <PSRBatchListing hasErrors isDashboard />;
      case PSRModalTypeEnum.PSR_HISTORY:
        return <PSRBatchListing isDashboard />;
      default:
        return <></>;
    }
  };

  return (
    <AppModalContainer
      title={
        type === PSRModalTypeEnum.SUBMIT_PSR
          ? 'Submit PSR'
          : type === PSRModalTypeEnum.PSR_ERROR_SUBMISSIONS
            ? 'PSR Error Submissions'
            : 'PSR History'
      }
      isOpen={isOpen}
      toggle={toggle}
      className="max-sm:w-[100vw"
      width={1250}
      minHeight="0"
      noPaddingBody
      hiddenFooter
    >
      {renderContentByType()}
    </AppModalContainer>
  );
};

export default PSRModal;
